<template>
  <div class="place" >
    <el-divider content-position="left">档案柜管理</el-divider>
    <el-row class="mb-10">
      <el-col :span="20" class="tr">
        <el-select v-model="searchArr.company" filterable remote reserve-keyword placeholder="输入公司" size="mini" clearable :remote-method="remoteMethod" :loading="loading" @change="handleCompanyChange">
          <el-option v-for="company in companies"
          :key="company.id"
          :label="company.company_name"
          :value="company.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" class="tr">
        <el-button type="primary" size="mini" @click="handleAddOpen">添加档案柜</el-button>
      </el-col>
    </el-row>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in editableTabs" :label="item.area" :name="item.area" :key="index">
        <el-row>
          <el-col :span="24">
            <div class="count" v-for="(con, index) in count" :key="index">
              <div v-if="con.area == item.area">
                <span>{{item.place_name ? item.place_name + '：' : ''}}</span>
                <span>合计 {{con.placeCount}} 个档案盒</span>
                <span>已存放 {{con.companyCount}} 家企业</span>
                <span>还可存放 {{con.remainCount}} 家企业</span>
                <span @click="handleDialogOpen(item.place_remark)"><i class="el-icon-question"></i></span>
                <span><el-button type="primary" size='mini' @click="handleEditOpen(item)">编辑档案柜</el-button></span>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="padding: .2rem" v-for="(row, rowIndex) in item.line" :key="rowIndex">
          <el-col :span="8" v-for="(col, colIndex) in item.column" :key="colIndex">
            <el-card shadow="always">
              <div slot="header" class="clearfix">
                <span>{{ item.area }} {{ row }}</span>
              </div>
              <div v-for="place in item.places" :key="place.id" class="text">
                <el-row v-if="place.line === row && place.column === col" class="item">
                  <el-col :span="20">
                    <span :id="'company-' + place.id" class="hide-style" :class="{active: isActive === 'company-' + place.id}">{{ item.area }}{{ row }}-{{ place.acode }}.
                      <span class="company-palce" @click="handleShow(place.id, item.area, row, place.acode, place.company_id, place.company_name)">{{ place.company_name ? place.company_name : '空档案盒' }}</span>
                    </span>
                  </el-col>
                  <el-col :span="4">
                    <el-dropdown trigger="click" @command="handleCommand" class="more-icon">
                      <span class="el-dropdown-link"><i class="el-icon-s-fold"></i></span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="{action: 'edit', id: place.id, companyId: place.company_id, company: place.company_name}">修改</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-col>
                  <el-divider></el-divider>
                </el-row>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-drawer
      title="添加区域"
      :visible.sync="areaDrawer"
      direction="rtl"
      :before-close="handleAreaBeforeClose"
      size="50%">
        <div class="m-tabs-content">
          <el-form :model="addData" :rules="rules" ref="addForm" label-width="100px">
            <el-form-item label="区域名" prop="area">
              <el-input v-model="addData.area" :size="inputSize" clear></el-input>
            </el-form-item>
            <el-form-item label="区域中文名" prop="place_name">
              <el-input v-model="addData.place_name" :size="inputSize" clear></el-input>
            </el-form-item>
            <el-form-item label="行数" prop="line">
              <el-input v-model="addData.line" :size="inputSize">
                <template slot="append">行</template>
              </el-input>
            </el-form-item>
            <el-form-item label="网格数/行" prop="column">
              <el-input v-model="addData.column" :size="inputSize">
                <template slot="append">个</template>
              </el-input>
            </el-form-item>
            <el-form-item label="位置数/网格" prop="nums">
              <el-input v-model="addData.nums" :size="inputSize">
                <template slot="append">个</template>
              </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="place_remark">
              <el-input type="textarea" v-model="addData.place_remark" :size="inputSize"></el-input>
            </el-form-item>
          </el-form>
          <el-row class="mt-10 tr">
            <el-button type="primary" size="mini" @click="handleSave('addForm')">添加</el-button>
          </el-row>
        </div>
    </el-drawer>
    <el-drawer
      title="编辑档案柜"
      :visible.sync="editDrawer"
      direction="rtl"
      :before-close="handleEditBeforeClose"
      size="50%">
        <div class="m-tabs-content">
          <el-form :model="upData" :rules="rules" ref="upForm" label-width="100px">
            <el-form-item label="区域名" prop="area">
              <el-input v-model="upData.area" :size="inputSize" clear></el-input>
            </el-form-item>
            <el-form-item label="区域中文名" prop="place_name">
              <el-input v-model="upData.place_name" :size="inputSize" clear></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="place_remark">
              <el-input type="textarea" v-model="upData.place_remark" :size="inputSize"></el-input>
            </el-form-item>
          </el-form>
          <el-row class="mt-10 tr">
            <el-button type="primary" size="mini" @click="handleUpSub()">保存</el-button>
          </el-row>
        </div>
    </el-drawer>
    <el-drawer
      :title="showTitle"
      :visible.sync="showDrawer"
      direction="rtl"
      :modal="false"
      :before-close="handleShowDrawerBeforeClose"
      size="50%">
        <div class="m-tabs-content">
          <el-tabs type="border-card" v-model="activeLogName">
            <el-tab-pane :label="showCompany" name="areaLog">
              <el-row class="mb-10">
                <el-col :span="4">
                  <span class="m-label">公司</span>
                </el-col>
                <el-col :span="20">
                  <el-select v-model="saveData.new_company_id" filterable remote reserve-keyword placeholder="输入公司" size="mini" clearable :remote-method="remoteMethod" :loading="loading">
                    <el-option v-for="company in companies"
                    :key="company.company_name + company.id"
                    :label="company.company_name"
                    :value="company.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row class="mt-10 tr">
                <el-button type="primary" size="mini" @click="handleUp()">保存</el-button>
              </el-row>
              <el-timeline>
                <el-timeline-item v-for="applicat in applicats" :key="applicat.id" :timestamp="applicat.created_at" placement="top">
                  <el-card>
                    <p>{{applicat.operate}}</p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane>
            <el-tab-pane label="档案盒历史记录">
              <el-timeline>
                <el-timeline-item v-for="operate in operates" :key="operate.id" :timestamp="operate.created_at" placement="top">
                  <el-card>
                    <p>{{operate.operate}}</p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane>
          </el-tabs>
        </div>
    </el-drawer>
    <el-dialog
      title="档案柜说明"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleDialogClose">
      <span>{{remark}}</span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Place',
  data () {
    return {

      inputSize: 'mini',
      areaDrawer: false,
      activeName: '',
      isActive: '',
      searchArr: {
        'company': ''
      },
      companies: [],
      loading: false,
      editableTabs: [],
      count: [],
      operates: [],
      applicats: [],
      addData: {
        area: '',
        line: 1,
        column: 1,
        nums: 1,
        place_name: null,
        place_remark: null
      },
      upData: {
        old_area: '',
        area: '',
        place_name: '',
        place_remark: ''
      },
      editDrawer: false,
      saveData: {
        pid: null,
        old_company_id: null,
        new_company_id: null
      },
      showTitle: '',
      showCompany: '空档案盒',
      activeLogName: 'areaLog',
      showDrawer: false,
      dialogVisible: false,
      remark: '',
      rules: {
        area: [
          { required: true, message: '请输入区域名称', trigger: 'blur' }
        ],
        line: [
          { required: true, message: '行数不能为空', trigger: 'blur' },
          { type: 'number', message: '必须为数字值', trigger: 'blur', transform: (value) => Number(value) }
        ],
        column: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { type: 'number', message: '必须为数字值', trigger: 'blur', transform: (value) => Number(value) }
        ],
        nums: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { type: 'number', message: '必须为数字值', trigger: 'blur', transform: (value) => Number(value) }
        ]
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getData () {
      this.$axios.get('/api/record/place_list')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.editableTabs = data.data.list
            this.count = data.data.header
            if (this.editableTabs.length > 0) {
              this.activeName = this.editableTabs[0].area
            }
          }
        })
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchCompanys(query)
        }, 200)
      } else {
        this.companies = []
      }
    },
    searchCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companies = data.data.companies
          }
        })
    },
    handleClick (tab, event) {},
    handleCommand (command) {
      console.log(command)
    },
    handleShow (id, area, row, acode, companyId, companyName) {
      this.$axios.get('/api/record/place_operate_list/' + id, {loadingClose: true})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.operates = data.data.operate_list
            this.applicats = data.data.applicat_list
            this.showTitle = area + row + '-' + acode + '档案盒'
            this.saveData.pid = id
            this.saveData.old_company_id = companyId
            this.saveData.new_company_id = companyId
            this.saveData.company = companyName
            if (companyId && companyName) {
              this.showCompany = companyName
              this.companies.push({id: companyId, company_name: companyName})
            }
            this.showDrawer = true
          }
        })
    },
    handleShowDrawerBeforeClose (done) {
      this.clearSaveData()
      done()
    },
    clearSaveData () {
      this.operates = []
      this.showTitle = ''
      this.showCompany = '空档案盒'
      this.saveData.pid = null
      this.saveData.old_company_id = null
      this.saveData.new_company_id = null
      this.saveData.company = null
      this.companies = []
      this.activeLogName = 'areaLog'
    },
    handleEditOpen (area) {
      this.upData.old_area = area.area
      this.upData.area = area.area
      this.upData.place_name = area.place_name
      this.upData.place_remark = area.place_remark
      this.editDrawer = true
    },
    handleEditBeforeClose (done) {
      this.clearUpData()
      done()
    },
    clearUpData () {
      this.upData.area = ''
      this.upData.place_name = ''
      this.upData.place_remark = ''
    },
    handleUpSub () {
      console.log(this.upData)
      this.$axios.post('/api/record/place_area_update', {old_area: this.upData.old_area, new_area: this.upData.area, place_name: this.upData.place_name, place_remark: this.upData.place_remark})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.getData()
            this.editDrawer = false
            this.clearUpData()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleUp () {
      this.$axios.post('/api/record/place_company_set/' + this.saveData.pid, {old_company_id: this.saveData.old_company_id, new_company_id: this.saveData.new_company_id})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.getData()
            this.showDrawer = false
            this.clearSaveData()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleCompanyChange (val) {
      if (!val) {
        this.isActive = ''
        return
      }

      this.$axios.get('/api/record/place_get_by_companyid/' + val)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.activeName = data.data.area
            this.isActive = 'company-' + data.data.id
            setTimeout(() => {
              document.querySelector('#company-' + data.data.id).scrollIntoView({behavior: 'smooth', block: 'center'})
            }, 500)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleAddOpen () {
      this.areaDrawer = true
    },
    handleAreaBeforeClose (done) {
      this.addData.area = ''
      this.addData.line = 1
      this.addData.column = 1
      this.addData.nums = 1
      this.addData.place_name = null
      this.addData.place_remark = null
      done()
    },
    handleSave (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/record/place_set', this.addData)
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.getData()
                this.$message.success(data.msg)
                this.areaDrawer = false
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    handleDialogOpen (remark) {
      this.remark = remark
      this.dialogVisible = true
    },
    handleDialogClose (done) {
      this.remark = ''
      done()
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  [v-cloak]
    display: none
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-collapse
    border-bottom 0
    border-top 0
  .el-collapse >>> .el-collapse-item__header
    color: #4C87FC
    font-weight bold
  .el-collapse >>> .el-collapse-item__arrow
    color: #4C87FC
  .place
    marginLeft()
    .hide-style
      display: inherit
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .el-icon-question, .el-icon-edit
      color: #409eff
      cursor: pointer
    .el-divider--horizontal
      margin: .3rem
  .tr
    text-align: right
  .mt-10
    margin-top: .2rem
  .mb-10
    margin-bottom: .2rem
  .text
    font-size: .28rem
  .item
    margin-bottom: .36rem
  .clearfix:before,
  .clearfix:after
    display: table
    content: ""
  .clearfix:after
    clear: both
  .more-icon
    float: right
    color: #5789F4
    cursor: pointer
  .active
    color: red
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    .el-row
      margin-bottom: .2rem
    .m-label
      line-height: .64rem
    .el-select
      width: 100%
  .company-palce
    cursor: pointer
  .company-palce:hover
    color: #5789f4
  .count span
    display: inline-block
    padding-left: .2rem
</style>



// WEBPACK FOOTER //
// src/pages/record_place/Place.vue